import React from 'react';
import {
	createCompanyAddress,
	getCompanyAddresses,
	updateCompanyAddress,
} from '@client/lib/api';
import useFetchedState from '@client/utils/hooks/useFetchedState';
import EditableDetails from '@client/components/EditableDetails/EditableDetails';
import styles from '../ManagementSettingsScreen/ManagementSettingsScreen.module.css';

const DEFAULT_ADDRESS = {
	invoiceFooter: '',
	showOnInvoice: false,
};

const CompanyAddress = () => {
	const [invoiceCompanyAddress, refreshCompanyAddress] = useFetchedState(async () => {
		return await getCompanyAddresses();
	}, []);

	const address = invoiceCompanyAddress?.[0] ?? null;

	const handleSave = async (values: any) => {
		if (address?.id) {
			await updateCompanyAddress(address.id, values);
		} else {
			await createCompanyAddress(values);
		}

		await refreshCompanyAddress();
	};

	const getCompanyAddressItems = () => {
		const {
			invoiceFooter,
			showOnInvoice,
		} = address ?? DEFAULT_ADDRESS;

		return [
			{
				key: 'invoiceFooter',
				label: 'Invoice Footer',
				value: invoiceFooter,
				editable: true,
				type: 'textarea',
				inputProps: { rows: 4 },
			},
			{
				key: 'showOnInvoice',
				label: 'Show on invoice',
				value: showOnInvoice,
				editable: true,
				type: 'switch',
				render: () => (showOnInvoice ? 'Yes' : 'No'),
			},
		];
	};

	if (invoiceCompanyAddress == null) {
		return null;
	}

	return (
		<EditableDetails
			key={(address?.id ?? 'new-company-address').toString()}
			className={styles.companyAddress}
			// @ts-ignore
			items={getCompanyAddressItems()}
			onSave={handleSave}
			title={(
				<div className={styles.titleContainer}>
					Invoice Footer
				</div>
			)}
		/>
	);
};

export default CompanyAddress;
